import {TripPage} from './trip'
import {TripAddPage} from './add/tripadd'
import {AddCalendarPage} from './addcalendar/addcalendar'
import {SelCalendarPage} from './calendar/selcalendar'
import {RemindPage} from './remind/remind'
import {RepeatPage} from './repeat/repeat'
import {RepeatTimePage} from './repeattime/repeattime'
import {TripSetPage} from './set/tripset'
import {TripView} from './tripview/tripview'

import { TripService } from './service/tripservice';

/*********
 * 日历应用中心，所有应用都在这里声明
 *
 * ***********/
export const TRIP_EX = [
  TripPage,
  TripAddPage,
  AddCalendarPage,
  SelCalendarPage,
  RemindPage,
  RepeatPage,
  RepeatTimePage,
  TripSetPage,
  TripView
];

export const TRIP_SERVICE = [
  TripService
];




// WEBPACK FOOTER //
// ./src/pages/trip/trip_ec.ts